var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / phone-call",
    clipPath: "url(#clip0_67_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7959 4.58329C14.6912 4.75798 15.514 5.19586 16.1591 5.8409C16.8041 6.48594 17.242 7.30879 17.4167 8.20413M13.7959 0.916626C15.656 1.12328 17.3906 1.95629 18.7149 3.27888C20.0392 4.60148 20.8744 6.33505 21.0834 8.19496M20.1667 15.51V18.26C20.1677 18.5153 20.1154 18.7679 20.0132 19.0019C19.9109 19.2358 19.7609 19.4457 19.5728 19.6183C19.3846 19.7909 19.1625 19.9223 18.9207 20.0041C18.6789 20.0859 18.4226 20.1163 18.1684 20.0933C15.3476 19.7868 12.6381 18.8229 10.2575 17.2791C8.0427 15.8717 6.16491 13.994 4.75752 11.7791C3.20833 9.38773 2.24424 6.66504 1.94335 3.83163C1.92045 3.57814 1.95057 3.32266 2.03181 3.08145C2.11305 2.84024 2.24363 2.61859 2.41522 2.43061C2.58682 2.24263 2.79567 2.09244 3.0285 1.9896C3.26132 1.88677 3.513 1.83353 3.76752 1.83329H6.51752C6.96238 1.82891 7.39366 1.98645 7.73097 2.27653C8.06827 2.56661 8.28859 2.96945 8.35085 3.40996C8.46692 4.29002 8.68218 5.15413 8.99252 5.98579C9.11585 6.31389 9.14254 6.67046 9.06944 7.01327C8.99633 7.35607 8.82648 7.67073 8.58002 7.91996L7.41585 9.08413C8.72078 11.379 10.6209 13.2792 12.9159 14.5841L14.08 13.42C14.3293 13.1735 14.6439 13.0037 14.9867 12.9305C15.3295 12.8574 15.6861 12.8841 16.0142 13.0075C16.8459 13.3178 17.71 13.5331 18.59 13.6491C19.0353 13.7119 19.442 13.9362 19.7327 14.2793C20.0234 14.6224 20.1778 15.0604 20.1667 15.51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_4027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.a0bc48297117d18bd9486bdd52ec22ec.svg";
export { ForwardRef as ReactComponent };